import React, { useEffect, useRef, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import Logo from "../../../images/logo/TezBikes.png";
import { FaUsers } from "react-icons/fa";
import { BiSolidDashboard } from "react-icons/bi";
import { IoIosArrowDown, IoIosArrowForward } from "react-icons/io";

const Sidebar = ({ sidebarOpen, setSidebarOpen }) => {
  const location = useLocation();
  const { pathname } = location;

  const trigger = useRef(null);
  const sidebar = useRef(null);

  // State for dropdown menu
  const [openDropdown, setOpenDropdown] = useState(null);

  // Close sidebar when clicking outside
  useEffect(() => {
    const clickHandler = ({ target }) => {
      if (!sidebar.current || !trigger.current) return;
      if (
        !sidebarOpen ||
        sidebar.current.contains(target) ||
        trigger.current.contains(target)
      )
        return;
      setSidebarOpen(false);
    };
    document.addEventListener("click", clickHandler);
    return () => document.removeEventListener("click", clickHandler);
  }, [sidebarOpen]);

  // Close sidebar on ESC key press
  useEffect(() => {
    const keyHandler = ({ keyCode }) => {
      if (!sidebarOpen || keyCode !== 27) return;
      setSidebarOpen(false);
    };
    document.addEventListener("keydown", keyHandler);
    return () => document.removeEventListener("keydown", keyHandler);
  }, [sidebarOpen]);

  // Toggle dropdown menu
  const toggleDropdown = (id) => {
    setOpenDropdown(openDropdown === id ? null : id);
  };

  return (
    <aside
      ref={sidebar}
      className={`absolute left-0 top-0 z-50 flex h-screen w-[16.125rem] flex-col overflow-y-hidden duration-300 ease-linear bg-[#252b3b] border-r-2 border-[#E4E4E41A] lg:static lg:translate-x-0 ${sidebarOpen ? "translate-x-0" : "-translate-x-full"
        }`}
      style={{
        boxShadow: "0 2px 4px rgba(0, 0, 0, 0.08)",
      }}
    >
      {/* Sidebar Header */}
      <div className="flex items-center justify-between px-6 py-[1.375rem] lg:py-[1.625rem]">
        <Link to="/">
          <img src={Logo} alt="Logo" width={170} />
        </Link>

        <button
          ref={trigger}
          onClick={() => setSidebarOpen(!sidebarOpen)}
          aria-controls="sidebar"
          aria-expanded={sidebarOpen}
          className="block lg:hidden text-white"
        >
          ☰
        </button>
      </div>

      {/* Sidebar Content */}
      <div className="no-scrollbar flex flex-col overflow-y-auto duration-300 ease-linear">
        <nav className="py-4 px-4">
          <h3 className="mb-4 ml-4 text-sm font-semibold text-white">MENU</h3>
          <ul className="mb-6 flex flex-col gap-1.5">
            {sidebarMenu.map((item) => (
              <li key={item.id}>
                {item.children ? (
                  <>
                    {/* Dropdown Button */}
                    <button
                      onClick={() => toggleDropdown(item.id)}
                      className={`flex w-full items-center justify-between px-4 py-2 rounded-sm text-text-color hover:bg-meta-4 hover:text-white ${pathname.startsWith(item.to)
                        ? "bg-[#333a48] text-white font-bold"
                        : ""
                        }`}
                    >
                      <div className="flex items-center gap-2.5">
                        {item.icon} {item.label}
                      </div>
                      {openDropdown === item.id ? (
                        <IoIosArrowDown />
                      ) : (
                        <IoIosArrowForward />
                      )}
                    </button>

                    {/* Dropdown Submenu */}
                    <ul
                      className={`pl-8 overflow-hidden transition-all duration-300 ${openDropdown === item.id ? "max-h-screen" : "max-h-0"
                        }`}
                    >
                      {item.children.map((subItem) => (
                        <li key={subItem.to}>
                          <Link
                            to={subItem.to}
                            className={`block mt-[1px] px-4 py-2 text-sm text-gray-300 hover:bg-[#333a48] rounded ${pathname === subItem.to
                              ? "bg-[#333a48] text-white"
                              : ""
                              }`}
                            onClick={() => setSidebarOpen(false)}
                          >
                            {subItem.label}
                          </Link>
                        </li>
                      ))}
                    </ul>
                  </>
                ) : (
                  <Link
                    to={item.to}
                    className={`flex items-center gap-2.5 px-4 py-2 rounded-sm text-text-color hover:bg-meta-4 hover:text-white ${pathname === item.to
                      ? "bg-[#333a48] text-white font-bold"
                      : ""
                      }`}
                    onClick={() => setSidebarOpen(false)}
                  >
                    {item.icon} {item.label}
                  </Link>
                )}
              </li>
            ))}
          </ul>
        </nav>
      </div>
    </aside>
  );
};

export default Sidebar;

// Sidebar menu items with dropdown
const sidebarMenu = [
  {
    id: 1,
    label: "Dashboard",
    to: "/admin/dashboard",
    icon: <BiSolidDashboard size={20} />,
  },
  {
    id: 2,
    label: "Add Bike",
    to: "/admin/bikes/add",
    icon: <BiSolidDashboard size={20} />,
  },
  {
    id: 3,
    label: "Bikes History",
    to: "/admin/bikes/history",
    icon: <BiSolidDashboard size={20} />,
  },
  {
    id: 4,
    label: "Bikes Inquiry",
    to: "/admin/bikes_inquiry",
    icon: <BiSolidDashboard size={20} />,
  },
  {
    id: 5,
    label: "Bike Section",
    icon: <FaUsers size={20} />,
    children: [
      { label: "Bike Categories", to: "/admin/categories" },
      { label: "Brands", to: "/admin/brands" },
      { label: "Budget", to: "/admin/budget" },
      { label: "Fuel Types", to: "/admin/fueltype" },
    ],
  },
  {
    id: 4,
    label: "Lead Management",
    to: "/admin/leadmanagement",
    icon: <BiSolidDashboard size={20} />,
  },
];
